import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MessageService } from 'primeng/api';
import { StudentService } from 'src/app/private/services/student.service';
import { SharedModule } from 'src/app/private/shared/shared.module';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';

@Component({
  selector: 'app-delete-student',
  standalone: true,
  imports: [SharedModule],
  templateUrl: './delete-student.component.html',
  styleUrl: './delete-student.component.scss'
})
export class DeleteStudentComponent {

  @Output() closeDialog = new EventEmitter<any>();
  @Input() editLeadData: any;
  @Output() reload = new EventEmitter<any>();
  isLoading = false;

  constructor(
    private api: StudentService,
    private localStorage: LocalStorageService,
    private messageService: MessageService
  ) { }

  handleCloseDialog() {
    this.closeDialog.emit();
  }

  getFullName(user: any) {
    return [user?.prefix, user?.first_name, user?.last_name]
      .filter(name => !!name)
      .join(' ');
  }

  handleDelete() {
    this.isLoading = true;

    const studentId = this.editLeadData?.student_id;
    
    if (!studentId) {
      this.messageService.add({ 
        severity: 'error', 
        summary: 'Error', 
        detail: 'Student ID not found' 
      });
      this.isLoading = false;
      return;
    }

    this.api.updateStudent({
      student_id: studentId,
      isArchived: true
    }).subscribe({
      next: (response) => {
        this.isLoading = false;
        this.reload.emit();
        this.messageService.add({ 
          severity: 'success', 
          summary: 'Success', 
          detail: 'Student deleted successfully' 
        });
        this.closeDialog.emit();
      },
      error: (error) => {
        this.messageService.add({ 
          severity: 'error', 
          summary: 'Error', 
          detail: error?.error?.message || 'Something went wrong' 
        });
        this.isLoading = false;
      }
    });
  }
}
